import identity from './product-identity.json' with { type: 'json' };
/** Shared with system messaging and generated install metadata. */
export const PRODUCT = Object.freeze(identity);
